import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-empty-state',
    templateUrl: './empty-state.component.html',
    styleUrls: ['./empty-state.component.css']
})
export class EmptyStateComponent implements OnChanges {
    @Input() msg: any;
    @Input() icon: any;
    iconUrl = '';
    constructor() {}
    ngOnChanges(changes: SimpleChanges) {
        this.iconUrl = this.icon ? 'assets/images/' + this.icon : 'assets/images/nodata.svg';
    }
}
